import { render, staticRenderFns } from "./ServiceQuestWaitDay.vue?vue&type=template&id=13ac03d0&"
import script from "./ServiceQuestWaitDay.vue?vue&type=script&lang=js&"
export * from "./ServiceQuestWaitDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports